import { render, staticRenderFns } from "./acuTechnic4.vue?vue&type=template&id=12be9d38&scoped=true&"
var script = {}
import style0 from "./acuTechnic4.vue?vue&type=style&index=0&id=12be9d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be9d38",
  null
  
)

export default component.exports